














import { Component, Vue } from 'vue-property-decorator'
import router from '@/router'
import { AuthService as _authService } from '@/services/auth.service'
import { UserService as _userService } from '@/services/user.service'
import { ProjectService as _projectService } from '@/services/project.service'
import { WorkbookService as _workbookService } from '@/services/workbook.service'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import { ProjectDto } from '@/models/dtos/projectDto'
import { EWorkingDayState } from '@/models/dtos/enums/eWorkingDayState'
import Filters from '@/components/project/Filters.vue'
import ProjectList from '@/components/project/ProjectList.vue'
import WorkbookEntryModal from '@/modals/WorkbookEntry.modal.vue'
import { WorkbookEntryDto } from '@/models/dtos/workbookEntryDto'
import { SimpleProjectDto } from '@/models/dtos/simpleProjectDto'
import { TemplateDto } from '@/models/dtos/templateDto'
import { mixins } from 'vue-class-component'
import { TemplateService as _templateService } from '@/services/template.service'
import { ProjectMixin } from '@/mixins/projectMixin'

@Component({
  components: {
    Filters,
    ProjectList,
    WorkbookEntryModal
  }
})
export default class Home extends mixins(ProjectMixin) {
  // Data
  private eWorkingDayState = EWorkingDayState;
  private dayState: EWorkingDayState = EWorkingDayState.NotStarted;
  private currentUser: UserInfoDto | null = null
  private userProjects: SimpleProjectDto[] = []
  private inactiveUserProjects: SimpleProjectDto[] = []
  private filteredUserProjects: SimpleProjectDto[] = []
  private templates: TemplateDto[] = []

  // Methods
  async applyFilters(searchPhrase: string, showInactive: boolean) {
    let results = [...this.userProjects]

    if (searchPhrase?.length > 1) {
      searchPhrase = searchPhrase.toLowerCase()
      results = results.filter((project: SimpleProjectDto) => project.name.toLowerCase().includes(searchPhrase))
    }

    // Get inactive
    if (showInactive) {
      if (!this.inactiveUserProjects.length) {
        this.inactiveUserProjects = await _projectService.getIncativeProjects()
      }

      results.push(...this.inactiveUserProjects)
    }

    this.filteredUserProjects = results
  }

  private async initUserProjects() {
    this.userProjects = await _projectService.getProjects()
    this.filteredUserProjects = [...this.userProjects]
  }

  private logout() {
    _authService.logout()
    router.push('/login')
  }

  // Lifecycle
  async created() {
    _authService.currentUser().subscribe(userInfo => {
      this.currentUser = userInfo
    })

    // Init
    this.templates = await _templateService.getProjectTemplates()
    this.initUserProjects()
  }
}
